module.exports = __webpack_public_path__ + "static/media/PCStarIcon.9d1d431b.svg";